import React, { useEffect, useRef } from 'react';
import { Chart } from 'chart.js/auto';
import axios from 'axios';
import config from '../config'
import PropTypes from 'prop-types';

const EarningsBubbleChart = ({ symbol }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const fetchBubbleData = async () => {
      try {
        const res = await axios.get(`${config.backendUrl}/api/markets/stock-earnings?ticker=${symbol}`);
        const raw = res.data.data;

        const estimated = raw.map((item, index) => ({
          x: index,
          y: item.estimatedEPS,
          r: 10,
          label: item.x,
          type: 'Estimate'
        }));

        const actual = raw.map((item, index) => ({
          x: index,
          y: item.actualEPS,
          r: 10,
          label: item.x,
          type: 'Actual'
        }));

        if (chartRef.current) chartRef.current.destroy();

        chartRef.current = new Chart(canvasRef.current, {
          type: 'bubble',
          data: {
            datasets: [
              {
                label: 'Estimated EPS',
                data: estimated,
                backgroundColor: 'rgba(40, 167, 69, 1)',
                borderColor: 'rgba(0, 123, 255, 1)',
              },
              {
                label: 'Actual EPS',
                data: actual,
                backgroundColor: 'rgb(2,255,0)',
                borderColor: 'rgba(40, 167, 69, 1)',
              }
            ]
          },
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: 'Earnings',
                font: { size: 18 },
                color: '#ffffff'
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const d = context.raw;
                    return `${d.type} EPS for ${d.label}: ${d.y}`;
                  }
                }
              }
            },
            scales: {
                x: {
                  type: 'category',
                  labels: raw.map(item => item.x),
                  offset: true,
                  title: {
                    display: true,
                    text: 'Fiscal Quarter',
                    color: '#aaa'
                  },
                  ticks: {
                    color: '#ccc'
                  }
                },
                y: {
                  title: {
                    display: true,
                    text: 'EPS Value',
                    color: '#aaa'
                  },
                  ticks: {
                    color: '#ccc'
                  }
                }
              }
              
          }
        });
      } catch (err) {
        console.error('Error fetching bubble chart data', err);
      }
    };

    fetchBubbleData();

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [symbol]);

  return <canvas ref={canvasRef} />;
};

EarningsBubbleChart.propTypes = {
    symbol: PropTypes.string.isRequired
};
export default EarningsBubbleChart;
